import { apiService } from 'api/apiService';
import { deepCaseConverter } from 'helpers';

/* Construct axios instance */
export const apiConfig = apiService.setApi();

/* Add an interceptor to add token */
apiConfig.interceptors.request.use((request) => {
  apiService.addToken(request);
  const customHeaders = request.data?.headers;
  return { ...request, data: { ...request.data, headers: customHeaders } };
});

apiConfig.interceptors.response.use(
  (response) => {
    /* Convert response to camelCase */
    const data = deepCaseConverter(response.data, 'camelCase');

    /*
      - Manually display toaster because middleware doesn't raise any error if Castelis http request has an error
      - Show toaster unless hideToast is present in request config

      data.status refers to the service response status (castelis / strapi / etc.)
      response.status refers to the middleware response status
    */

    const errorStatus = [400, 401, 403, 404, 422, 500];
    if (errorStatus.includes(data.status) && !response?.config?.hideToast) {
      apiService.displayToast(data);
    }

    return { ...response, data };
  },
  (error) => {
    // if middleware returns 401, logout user, reset store and redirect to login page``
    if (error?.response?.status === 401) {
      apiService.logoutUser();
    } else if (error.code === 'ERR_CANCELED') {
      // Ignore AbortController errors
      return Promise.resolve(error);
    } else {
      apiService.handleError(error);
    }
  }
);
